import { CustomConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { Adresse } from '@/model/adresse';
import { ArticleLieuDepart } from '@/model/article-lieu-depart';
import { DateConverter } from '../converters/datesConverters';
import { ReglementCommande } from './reglement-commande';

@JsonObject
export class LigneCommande {
  @JsonProperty(Number)
  @Optional
  idLigne?: number;

  @JsonProperty(ArticleLieuDepart)
  articleLieuDepart?: ArticleLieuDepart;

  @JsonProperty(String)
  @Optional
  modeCamion?: string;

  @JsonProperty(Number)
  qteLivr?: number;

  @JsonProperty(Number)
  quantiteUnitaire?: number;

  @JsonProperty(String)
  codeConditionnement: string

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  dateDebutLivraison: Date;

  @JsonProperty(String)
  @CustomConverter(DateConverter)
  @Optional
  dateFinLivraison: Date;

  @JsonProperty(Adresse)
  @Optional
  adresseLivraison?: Adresse;

  @JsonProperty(ReglementCommande)
  reglement?: ReglementCommande;

  @JsonProperty(String)
  @Optional
  commentaire?: string;
}
